import type { LocalePack } from "./types";

const perks = [
  {
    title: "Bez kaucji",
    text: "Wynajmujesz samochód bez blokowania kaucji i bez karty kredytowej.",
  },
  {
    title: "Ceny od 35 EUR/dobę",
    text: "Przejrzysty cennik w EUR i RON, bez ukrytych opłat i niespodzianek na miejscu.",
  },
  {
    title: "Pełne ubezpieczenie",
    text: "W cenie masz ubezpieczenie RCA i CASCO, rovinietę oraz nielimitowany przebieg.",
  },
  {
    title: "Odbiór 24/7",
    text: "Odbierzesz auto o dowolnej porze na lotnisku Otopeni lub w naszym biurze w Bukareszcie.",
  },
];

const airportPerksOtopeni = [
  {
    title: "Darmowy odbiór na OTP",
    text: "Bezpłatnie odbierzesz samochód bezpośrednio przy terminalu lotniska Henri Coandă.",
  },
  {
    title: "Bez kaucji i karty kredytowej",
    text: "Płacisz kartą debetową, gotówką (EUR/RON) lub przelewem — bez blokady środków.",
  },
  {
    title: "28 aut w flocie",
    text: "Wybierzesz kompakt, SUV lub 7-osobowy minivan dopasowany do Twojej podróży.",
  },
  {
    title: "Dostawa do Bukaresztu",
    text: "Za 20 EUR dowieziemy auto pod dowolny adres w mieście, jeśli nie odbierasz go na lotnisku.",
  },
];

const guidePerks = [
  {
    title: "Nielimitowany przebieg",
    text: "Zaplanujesz długą trasę bez liczenia kilometrów i bez dopłat za dystans.",
  },
  {
    title: "Rovinieta w cenie",
    text: "Winieta drogowa jest już wliczona, więc nie musisz jej kupować osobno przed wyjazdem.",
  },
  {
    title: "Ubezpieczenie RCA+CASCO",
    text: "Górskie i nadmorskie trasy pokonujesz z pełnym ubezpieczeniem od odpowiedzialności i autocasco.",
  },
  {
    title: "Wsparcie na WhatsApp",
    text: "W razie pytań w trasie napiszesz do nas bezpośrednio na WhatsApp +40738792499.",
  },
];

const rulesPerks = [
  {
    title: "Rovinieta wliczona",
    text: "Nie musisz samodzielnie kupować winiety — jest już aktywna w naszych samochodach.",
  },
  {
    title: "Auta przygotowane na sezon",
    text: "Zimą nasze samochody mają opony zimowe zgodnie z rumuńskimi przepisami.",
  },
  {
    title: "Bez kaucji",
    text: "Formalności ograniczamy do minimum — bez kaucji i bez karty kredytowej.",
  },
  {
    title: "Kontakt na WhatsApp",
    text: "Masz pytanie o przepisy drogowe w Rumunii? Napisz do nas na WhatsApp +40738792499.",
  },
];

const deliveryNote =
  "Nasze biuro znajduje się w Bukareszcie, ale organizujemy dostawę samochodu w inne miejsce w Rumunii na zapytanie przez WhatsApp — w tym wynajem jednokierunkowy i dostawę międzymiastową na podstawie indywidualnej wyceny.";

export const pl: LocalePack = {
  code: "pl",
  htmlLang: "pl",
  dir: "ltr",
  ui: {
    label: "Polski",
    nav: {
      country: "Rumunia",
      airports: "Lotniska",
      cities: "Miasta",
      guides: "Przewodniki",
    },
    bookCta: "Zarezerwuj auto",
    fleetCta: "Zobacz flotę",
    whatsappCta: "Napisz na WhatsApp",
    fleetTitle: "Nasza flota",
    fleetSubtitle: "28 samochodów w różnych klasach — od miejskich po 7-osobowe minivany.",
    faqTitle: "Najczęściej zadawane pytania",
    mapTitle: "Gdzie nas znajdziesz",
    relatedTitle: "Zobacz również",
    priceNote: "Ceny podane w EUR, płatność możliwa również w RON.",
    breadcrumbHome: "Strona główna",
  },
  pages: {
    country: {
      slug: "",
      title: "Wynajem auta Rumunia — ceny od 35 EUR/dobę | carentals.ro",
      description:
        "Wynajem auta Rumunia bez kaucji i karty kredytowej. 28 aut, ubezpieczenie RCA+CASCO, rovinieta i nielimitowany przebieg w cenie. Odbiór 24/7.",
      eyebrow: "Wynajem samochodów w całej Rumunii",
      h1: "Wynajem auta Rumunia — szybko, bez kaucji, bez ukrytych kosztów",
      intro:
        "carentals.ro to lokalna wypożyczalnia z siedzibą w Bukareszcie, oferująca wynajem auta w Rumunii dla turystów i biznesu. Odbierzesz samochód na lotnisku Otopeni lub w naszym biurze, a resztę Rumunii zwiedzisz bez limitu kilometrów.",
      perks,
      sections: [
        {
          h2: "Dlaczego warto wynająć auto właśnie u nas",
          body: [
            "Nasza flota liczy 28 samochodów — od małych miejskich modeli po przestronne SUV-y i minivany 7-osobowe. Każdy wynajem obejmuje ubezpieczenie RCA i CASCO, rovinietę oraz nielimitowany przebieg, więc nie musisz doliczać dodatkowych kosztów.",
            "Nie wymagamy kaucji ani karty kredytowej — płacisz kartą debetową, gotówką w EUR lub RON, albo przelewem. Dzięki temu wynajem auta w Rumunii jest szybki i wygodny nawet dla osób podróżujących po raz pierwszy.",
          ],
        },
        {
          h2: "Odbiór na lotnisku i w Bukareszcie",
          body: [
            "Darmowy odbiór samochodu jest możliwy w naszym biurze przy Bulevardul Regina Elisabeta 33 w Bukareszcie oraz bezpośrednio na lotnisku Henri Coandă (Otopeni). Odbiór działa 24 godziny na dobę, 7 dni w tygodniu.",
            "Jeśli potrzebujesz dostawy pod inny adres w Bukareszcie, zorganizujemy ją za 20 EUR. Dostawę do innych miast Rumunii ustalamy indywidualnie przez WhatsApp +40738792499.",
          ],
        },
        {
          h2: "Ceny i warunki wynajmu",
          body: [
            "Ceny wynajmu zaczynają się od 35 EUR za dobę i zależą od klasy samochodu oraz długości wynajmu — im dłużej wynajmujesz, tym korzystniejsza stawka dzienna. Wszystkie ceny są jasno przedstawione przed rezerwacją.",
            "Płatność akceptujemy w EUR lub RON, kartą debetową, gotówką lub przelewem. Nie blokujemy żadnej kwoty na karcie jako kaucji, co odróżnia nas od wielu międzynarodowych wypożyczalni.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy do wynajmu auta w Rumunii potrzebna jest kaucja?",
          a: "Nie, nie pobieramy kaucji ani nie wymagamy karty kredytowej. Wystarczy karta debetowa, gotówka lub przelew.",
        },
        {
          q: "Gdzie mogę odebrać samochód?",
          a: "Odbiór jest bezpłatny w naszym biurze w Bukareszcie oraz na lotnisku Otopeni, dostępny 24/7.",
        },
        {
          q: "Czy w cenie jest ubezpieczenie i rovinieta?",
          a: "Tak, każdy wynajem obejmuje ubezpieczenie RCA i CASCO, rovinietę oraz nielimitowany przebieg.",
        },
        {
          q: "Jakimi walutami mogę zapłacić?",
          a: "Akceptujemy płatność w EUR i RON, kartą debetową, gotówką lub przelewem bankowym.",
        },
      ],
      keywords: "wynajem auta rumunia, wypożyczalnia samochodów rumunia, wynajem samochodu bukareszt",
    },

    "airport-otopeni": {
      slug: "wynajem-samochodu-bukareszt-lotnisko-otopeni",
      title: "Wynajem samochodu Bukareszt lotnisko Otopeni | carentals.ro",
      description:
        "Wynajem auta Otopeni bez kaucji — darmowy odbiór na lotnisku Henri Coandă, ceny od 35 EUR/dobę, ubezpieczenie i rovinieta w cenie.",
      eyebrow: "Lotnisko Henri Coandă (OTP)",
      h1: "Wynajem samochodu Bukareszt lotnisko — odbiór prosto z terminalu",
      intro:
        "Lądujesz na lotnisku Otopeni i potrzebujesz auta od razu? Wynajem auta Otopeni w carentals.ro obejmuje darmowy odbiór przy terminalu, bez kaucji i bez karty kredytowej. Rezerwację przygotujesz online, a klucze odbierzesz o każdej porze dnia i nocy.",
      perks: airportPerksOtopeni,
      sections: [
        {
          h2: "Jak wygląda odbiór auta na Otopeni",
          body: [
            "Po wyjściu z terminalu skontaktuj się z nami przez WhatsApp +40738792499, a nasz przedstawiciel podjedzie z samochodem bezpośrednio pod lotnisko. Cały proces zajmuje zwykle kilkanaście minut.",
            "Odbiór działa 24 godziny na dobę, więc niezależnie od godziny lądowania Twojego samolotu, auto będzie na Ciebie czekać. Formalności ograniczamy do okazania prawa jazdy i dowodu tożsamości.",
          ],
        },
        {
          h2: "Ceny i wybór samochodu na lotnisku",
          body: [
            "Wynajem samochodu na lotnisku Otopeni zaczyna się od 35 EUR za dobę. Do wyboru masz auta miejskie, SUV-y oraz 7-osobowe minivany idealne dla większych grup i rodzin.",
            "Każda rezerwacja obejmuje ubezpieczenie RCA i CASCO, rovinietę oraz nielimitowany przebieg, dzięki czemu od razu ruszysz w trasę po Rumunii bez dodatkowych formalności.",
          ],
        },
        {
          h2: "Zwrot auta i dostawa w Bukareszcie",
          body: [
            "Samochód możesz zwrócić w tym samym miejscu na lotnisku lub w naszym biurze przy Bulevardul Regina Elisabeta 33 w Bukareszcie — bez dodatkowych opłat.",
            "Jeśli wolisz odebrać lub zostawić auto pod innym adresem w Bukareszcie, taka dostawa kosztuje 20 EUR. Dostawę do innych miast ustalamy indywidualnie na WhatsApp.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy odbiór na lotnisku Otopeni jest darmowy?",
          a: "Tak, odbiór samochodu bezpośrednio na lotnisku Henri Coandă jest bezpłatny i dostępny 24/7.",
        },
        {
          q: "Czy muszę zostawić kaucję na lotnisku?",
          a: "Nie, wynajem auta Otopeni nie wymaga kaucji ani karty kredytowej.",
        },
        {
          q: "Ile kosztuje wynajem samochodu na lotnisku?",
          a: "Ceny zaczynają się od 35 EUR za dobę, w zależności od wybranego modelu i długości wynajmu.",
        },
        {
          q: "Czy mogę zwrócić auto w innym miejscu niż lotnisko?",
          a: "Tak, możesz zwrócić auto w naszym biurze w Bukareszcie lub zamówić dostawę pod inny adres za 20 EUR.",
        },
      ],
      keywords: "wynajem samochodu bukareszt lotnisko, wynajem auta otopeni, wynajem auta henri coanda",
    },

    "airport-cluj": {
      slug: "wynajem-auta-lotnisko-cluj",
      title: "Wynajem auta lotnisko Cluj (CLJ) | carentals.ro",
      description:
        "Wynajem samochodu na lotnisku w Cluj — dostawa z Bukaresztu na zapytanie, ceny od 35 EUR/dobę, bez kaucji, ubezpieczenie w cenie.",
      eyebrow: "Lotnisko Cluj-Napoca (CLJ)",
      h1: "Wynajem auta na lotnisku w Cluj",
      intro:
        "Podróżujesz do Klużu i potrzebujesz samochodu na miejscu? carentals.ro dostarczy auto z Bukaresztu na lotnisko w Cluj-Napoca po wcześniejszym uzgodnieniu. Otrzymasz te same warunki co w stolicy: bez kaucji, z pełnym ubezpieczeniem i nielimitowanym przebiegiem.",
      perks,
      sections: [
        {
          h2: "Dostawa samochodu do Cluj",
          body: [
            "Nasza baza znajduje się w Bukareszcie, dlatego dostawę samochodu na lotnisko w Cluj organizujemy indywidualnie po kontakcie na WhatsApp +40738792499. Podamy Ci dokładną wycenę i termin dostępności auta.",
            "Możliwy jest również wynajem jednokierunkowy, jeśli chcesz odebrać auto w Cluj, a zwrócić je w Bukareszcie lub w innym mieście — szczegóły ustalamy indywidualnie przed rezerwacją.",
          ],
        },
        {
          h2: "Warunki wynajmu takie same jak w stolicy",
          body: [
            "Niezależnie od miejsca odbioru, każdy wynajem obejmuje ubezpieczenie RCA i CASCO, rovinietę oraz nielimitowany przebieg. Ceny startują od 35 EUR za dobę.",
            "Nie pobieramy kaucji ani nie wymagamy karty kredytowej — płacisz kartą debetową, gotówką w EUR/RON lub przelewem, tak samo jak przy odbiorze w Bukareszcie.",
          ],
        },
        {
          h2: "Zwiedzanie Transylwanii z Cluj",
          body: [
            "Cluj-Napoca to świetny punkt wypadowy do zwiedzania Transylwanii — stąd blisko do Turdy, Alba Iulia czy gór Apuseni. Nielimitowany przebieg pozwala planować trasy bez ograniczeń.",
            "Dzięki wliczonej rovinietcie od razu wjedziesz na drogi krajowe bez dodatkowych formalności przy granicy regionu czy w trakcie podróży.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy dostarczycie auto na lotnisko w Cluj?",
          a: "Tak, dostawę z Bukaresztu do Cluj organizujemy na zapytanie przez WhatsApp, z indywidualną wyceną.",
        },
        {
          q: "Czy mogę zwrócić auto w innym mieście niż Cluj?",
          a: "Tak, oferujemy wynajem jednokierunkowy — szczegóły ustalamy przed rezerwacją.",
        },
        {
          q: "Czy warunki wynajmu różnią się od tych w Bukareszcie?",
          a: "Nie, cena od 35 EUR/dobę, ubezpieczenie, rovinieta i brak kaucji obowiązują tak samo jak w stolicy.",
        },
        {
          q: "Ile trwa organizacja dostawy do Cluj?",
          a: "Zależy od terminu i dostępności auta — im wcześniej się z nami skontaktujesz, tym łatwiej dopasujemy termin.",
        },
      ],
      keywords: "wynajem auta cluj, wynajem samochodu lotnisko cluj, wypożyczalnia aut cluj napoca",
    },

    "airport-iasi": {
      slug: "wynajem-auta-lotnisko-iasi",
      title: "Wynajem auta lotnisko Iasi (IAS) | carentals.ro",
      description:
        "Wynajem samochodu w Iasi — dostawa z Bukaresztu po ustaleniu, ceny od 35 EUR/dobę, bez kaucji, RCA+CASCO i rovinieta w cenie.",
      eyebrow: "Lotnisko Iași (IAS)",
      h1: "Wynajem auta na lotnisku w Iasi",
      intro:
        "Wynajem samochodu w Iasi organizujemy poprzez dostawę auta z Bukaresztu na zapytanie. Otrzymasz taki sam standard usługi jak przy odbiorze w stolicy — bez kaucji, z pełnym ubezpieczeniem i nielimitowanym przebiegiem.",
      perks,
      sections: [
        {
          h2: "Jak zamówić dostawę do Iasi",
          body: [
            "Ponieważ nasza baza samochodów znajduje się w Bukareszcie, dostawę do Iasi ustalamy indywidualnie — napisz do nas na WhatsApp +40738792499, podając daty i miejsce odbioru.",
            "Przygotujemy wycenę dostawy oraz sprawdzimy dostępność wybranego modelu. Możliwy jest też wynajem jednokierunkowy z odbiorem w Iasi i zwrotem w innym mieście.",
          ],
        },
        {
          h2: "Cennik i formalności",
          body: [
            "Cena wynajmu zaczyna się od 35 EUR za dobę, do tego dochodzi jednorazowy koszt dostawy ustalany indywidualnie w zależności od odległości i terminu.",
            "Nie wymagamy kaucji ani karty kredytowej — zapłacisz kartą debetową, gotówką w EUR/RON lub przelewem, dokładnie tak jak w naszym biurze w Bukareszcie.",
          ],
        },
        {
          h2: "Podróż po Mołdawii z Iasi",
          body: [
            "Iasi to dobry punkt startowy do zwiedzania regionu Mołdawii — klasztorów Bukowiny, Suczawy czy Cetatii de Scaun. Nielimitowany przebieg pozwala swobodnie planować dłuższe wycieczki.",
            "Rovinieta wliczona w cenę oznacza, że od razu po odbiorze auta możesz wjechać na drogi krajowe bez dodatkowych opłat.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy można wynająć auto bezpośrednio w Iasi?",
          a: "Tak, organizujemy dostawę samochodu z Bukaresztu do Iasi po wcześniejszym uzgodnieniu terminu i wyceny.",
        },
        {
          q: "Ile kosztuje dostawa auta do Iasi?",
          a: "Koszt zależy od odległości i terminu — dokładną wycenę otrzymasz po kontakcie na WhatsApp.",
        },
        {
          q: "Czy jest możliwy wynajem jednokierunkowy z Iasi?",
          a: "Tak, możliwy jest odbiór w Iasi i zwrot w innym mieście, po wcześniejszym ustaleniu szczegółów.",
        },
        {
          q: "Czy w cenie jest ubezpieczenie?",
          a: "Tak, każdy wynajem obejmuje ubezpieczenie RCA i CASCO oraz rovinietę.",
        },
      ],
      keywords: "wynajem auta iasi, wynajem samochodu lotnisko iasi, wypożyczalnia aut iasi",
    },

    "airport-timisoara": {
      slug: "wynajem-auta-lotnisko-timisoara",
      title: "Wynajem auta lotnisko Timisoara (TSR) | carentals.ro",
      description:
        "Wynajem samochodu w Timisoarze — dostawa z Bukaresztu na zapytanie, ceny od 35 EUR/dobę, bez kaucji, ubezpieczenie w cenie.",
      eyebrow: "Lotnisko Timișoara (TSR)",
      h1: "Wynajem auta na lotnisku w Timisoarze",
      intro:
        "Wynajem auta w Timisoarze realizujemy poprzez dostawę samochodu z naszej bazy w Bukareszcie. Ustal z nami termin i miejsce odbioru, a otrzymasz auto z pełnym ubezpieczeniem, rovinietą i bez kaucji.",
      perks,
      sections: [
        {
          h2: "Dostawa auta do Timisoary",
          body: [
            "Ponieważ Timisoara leży daleko od naszej bazy w Bukareszcie, dostawę samochodu ustalamy indywidualnie na WhatsApp +40738792499, z jasną wyceną kosztu transportu.",
            "Możliwy jest wynajem jednokierunkowy — odbierzesz auto w Timisoarze, a zwrócisz je w Bukareszcie lub innym mieście, w zależności od ustaleń.",
          ],
        },
        {
          h2: "Cena i warunki",
          body: [
            "Stawka za wynajem zaczyna się od 35 EUR za dobę, niezależnie od miejsca odbioru. Doliczamy jedynie koszt dostawy, ustalany indywidualnie.",
            "Podobnie jak w Bukareszcie, nie pobieramy kaucji ani nie wymagamy karty kredytowej — akceptujemy kartę debetową, gotówkę w EUR/RON lub przelew.",
          ],
        },
        {
          h2: "Banat i pogranicze z Serbią i Węgrami",
          body: [
            "Timisoara to dogodny punkt wypadowy w kierunku Banatu oraz pogranicza z Serbią i Węgrami. Nielimitowany przebieg pozwala swobodnie eksplorować region bez dopłat.",
            "Rovinieta wliczona w cenę oznacza brak dodatkowych formalności przy wjeździe na drogi krajowe zaraz po odbiorze samochodu.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy mogę wynająć auto bezpośrednio w Timisoarze?",
          a: "Tak, organizujemy dostawę auta z Bukaresztu do Timisoary po wcześniejszym uzgodnieniu.",
        },
        {
          q: "Jak długo trwa organizacja dostawy?",
          a: "Zależy od terminu rezerwacji — im wcześniej się zgłosisz, tym łatwiej dopasujemy dostępność.",
        },
        {
          q: "Czy dostawa jest płatna?",
          a: "Tak, koszt dostawy ustalamy indywidualnie w zależności od odległości i terminu.",
        },
        {
          q: "Czy nadal obowiązuje brak kaucji?",
          a: "Tak, warunki są identyczne jak w Bukareszcie — bez kaucji i bez karty kredytowej.",
        },
      ],
      keywords: "wynajem auta timisoara, wynajem samochodu lotnisko timisoara, wypożyczalnia aut timisoara",
    },

    "airport-sibiu": {
      slug: "wynajem-auta-lotnisko-sibiu",
      title: "Wynajem auta lotnisko Sibiu (SBZ) | carentals.ro",
      description:
        "Wynajem samochodu w Sibiu — dostawa z Bukaresztu na zapytanie, ceny od 35 EUR/dobę, bez kaucji, RCA+CASCO i rovinieta w cenie.",
      eyebrow: "Lotnisko Sibiu (SBZ)",
      h1: "Wynajem auta na lotnisku w Sibiu",
      intro:
        "Sibiu to popularny punkt startowy do Transfogarskiej i Transylwanii. Samochód dostarczymy z Bukaresztu po wcześniejszym uzgodnieniu, z pełnym ubezpieczeniem, rovinietą i bez kaucji.",
      perks,
      sections: [
        {
          h2: "Jak zamówić auto w Sibiu",
          body: [
            "Napisz do nas na WhatsApp +40738792499 z datami i miejscem odbioru, a przygotujemy wycenę dostawy samochodu z Bukaresztu do Sibiu.",
            "Dostępny jest również wynajem jednokierunkowy, jeśli planujesz dalszą trasę i chcesz zwrócić auto w innym mieście niż Sibiu.",
          ],
        },
        {
          h2: "Cennik i sposób płatności",
          body: [
            "Cena wynajmu zaczyna się od 35 EUR za dobę plus koszt dostawy ustalany indywidualnie. Płatność możliwa kartą debetową, gotówką w EUR/RON lub przelewem.",
            "Tak jak w Bukareszcie, nie pobieramy kaucji ani nie wymagamy karty kredytowej — formalności ograniczamy do minimum.",
          ],
        },
        {
          h2: "Sibiu jako baza wypadowa na Transfogarską",
          body: [
            "Z Sibiu masz blisko na słynną trasę Transfogarską (DN7C) oraz do Fagaraszu i jeziora Bâlea. Nielimitowany przebieg pozwala swobodnie planować górskie wycieczki.",
            "Rovinieta wliczona w cenę oznacza, że od razu po odbiorze auta możesz wyruszyć w góry bez dodatkowych opłat drogowych.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy dostarczycie auto na lotnisko w Sibiu?",
          a: "Tak, dostawę z Bukaresztu organizujemy na zapytanie, z indywidualną wyceną kosztu transportu.",
        },
        {
          q: "Czy Sibiu to dobra baza do trasy Transfogarskiej?",
          a: "Tak, Sibiu leży blisko początku trasy DN7C, popularnej wśród podróżujących górskimi serpentynami.",
        },
        {
          q: "Czy mogę zwrócić auto w innym mieście?",
          a: "Tak, oferujemy wynajem jednokierunkowy po wcześniejszym uzgodnieniu szczegółów.",
        },
        {
          q: "Czy muszę wpłacić kaucję?",
          a: "Nie, wynajem nie wymaga kaucji ani karty kredytowej, niezależnie od miejsca odbioru.",
        },
      ],
      keywords: "wynajem auta sibiu, wynajem samochodu lotnisko sibiu, wypożyczalnia aut sibiu",
    },

    "city-bucharest": {
      slug: "wynajem-samochodu-bukareszt",
      title: "Wynajem samochodu Bukareszt — biuro i lotnisko | carentals.ro",
      description:
        "Wynajem samochodu w Bukareszcie od 35 EUR/dobę. Odbiór w biurze przy Regina Elisabeta 33 lub na lotnisku Otopeni, bez kaucji.",
      eyebrow: "Stolica Rumunii",
      h1: "Wynajem samochodu w Bukareszcie",
      intro:
        "Nasze biuro mieści się w centrum Bukaresztu, przy Bulevardul Regina Elisabeta 33, a auto odbierzesz też bezpłatnie na lotnisku Otopeni. Wynajem obejmuje pełne ubezpieczenie, rovinietę i nielimitowany przebieg — bez kaucji i karty kredytowej.",
      perks,
      sections: [
        {
          h2: "Biuro w centrum i lotnisko Otopeni",
          body: [
            "Odbiór samochodu jest darmowy zarówno w naszym biurze przy Bulevardul Regina Elisabeta 33, jak i na lotnisku Henri Coandă (Otopeni), przez całą dobę, 7 dni w tygodniu.",
            "Jeśli potrzebujesz auta pod innym adresem w Bukareszcie, dostawa kosztuje 20 EUR. Wystarczy wcześniej zgłosić to podczas rezerwacji lub napisać na WhatsApp.",
          ],
        },
        {
          h2: "Poruszanie się po Bukareszcie i okolicach",
          body: [
            "Własny samochód w Bukareszcie ułatwia dotarcie do dzielnic poza centrum, do centrów handlowych czy na wycieczki jednodniowe do zamku Peleș czy Snagov.",
            "Dzięki nielimitowanemu przebiegowi i wliczonej rovinietcie możesz swobodnie planować zarówno jazdę po mieście, jak i dłuższe trasy poza Bukareszt.",
          ],
        },
        {
          h2: "Ceny i formy płatności w Bukareszcie",
          body: [
            "Ceny wynajmu w Bukareszcie zaczynają się od 35 EUR za dobę i zależą od klasy pojazdu oraz długości wynajmu.",
            "Zapłacisz kartą debetową, gotówką w EUR lub RON, albo przelewem bankowym — bez kaucji i bez blokowania środków na karcie kredytowej.",
          ],
        },
      ],
      faqs: [
        {
          q: "Gdzie znajduje się biuro carentals.ro w Bukareszcie?",
          a: "Nasze biuro mieści się przy Bulevardul Regina Elisabeta 33, w centrum Bukaresztu.",
        },
        {
          q: "Czy mogę odebrać auto na lotnisku, a zwrócić w biurze?",
          a: "Tak, odbiór i zwrot możesz dowolnie łączyć między lotniskiem Otopeni a biurem w Bukareszcie, bez dodatkowych opłat.",
        },
        {
          q: "Ile kosztuje dostawa pod inny adres w Bukareszcie?",
          a: "Dostawa pod dowolny adres w Bukareszcie kosztuje 20 EUR.",
        },
        {
          q: "Czy do wynajmu potrzebna jest karta kredytowa?",
          a: "Nie, akceptujemy kartę debetową, gotówkę w EUR/RON lub przelew, bez wymogu karty kredytowej.",
        },
      ],
      keywords: "wynajem samochodu bukareszt, wypożyczalnia aut bukareszt, wynajem auta bukareszt",
    },

    "city-brasov": {
      slug: "wynajem-samochodu-brasov",
      title: "Wynajem samochodu Braszów (Brasov) | carentals.ro",
      description:
        "Wynajem samochodu w Braszowie — dostawa z Bukaresztu na zapytanie, ceny od 35 EUR/dobę, bez kaucji, ubezpieczenie w cenie.",
      eyebrow: "Brama Transylwanii",
      h1: "Wynajem samochodu w Braszowie",
      intro:
        "Braszów to jedno z najczęściej odwiedzanych miast Transylwanii. Samochód dostarczymy z Bukaresztu po wcześniejszym uzgodnieniu, z pełnym ubezpieczeniem, rovinietą i bez kaucji.",
      perks,
      sections: [
        {
          h2: "Dostawa samochodu do Braszowa",
          body: [
            "Nasza flota bazuje w Bukareszcie, dlatego dostawę do Braszowa organizujemy indywidualnie — napisz na WhatsApp +40738792499, a przygotujemy wycenę i termin.",
            "Możliwy jest też wynajem jednokierunkowy, np. odbiór w Braszowie i zwrot w Bukareszcie po zakończeniu podróży po Transylwanii.",
          ],
        },
        {
          h2: "Zamek Bran, Peleș i okolice Braszowa",
          body: [
            "Z Braszowa masz blisko do zamku Bran, pałacu Peleș w Sinai oraz do Poiany Braszów. Nielimitowany przebieg pozwala zwiedzać te miejsca bez dodatkowych opłat za kilometry.",
            "Rovinieta wliczona w cenę oznacza, że od razu po odbiorze auta możesz wjechać na drogi krajowe łączące te atrakcje.",
          ],
        },
        {
          h2: "Cennik i warunki wynajmu",
          body: [
            "Ceny zaczynają się od 35 EUR za dobę, a dodatkowo doliczany jest koszt dostawy z Bukaresztu, ustalany indywidualnie w zależności od terminu.",
            "Płatność przyjmujemy w EUR lub RON, kartą debetową, gotówką lub przelewem — bez kaucji i bez karty kredytowej.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy można odebrać auto bezpośrednio w Braszowie?",
          a: "Tak, dostarczamy samochód z Bukaresztu do Braszowa po wcześniejszym uzgodnieniu terminu i wyceny.",
        },
        {
          q: "Czy Braszów to dobra baza do zwiedzania Transylwanii?",
          a: "Tak, z Braszowa łatwo dotrzeć do zamku Bran, pałacu Peleș i wielu innych atrakcji regionu.",
        },
        {
          q: "Ile kosztuje dostawa do Braszowa?",
          a: "Koszt dostawy ustalamy indywidualnie w zależności od terminu i odległości — napisz do nas na WhatsApp.",
        },
        {
          q: "Czy mogę zwrócić auto w innym mieście?",
          a: "Tak, oferujemy wynajem jednokierunkowy po wcześniejszym ustaleniu szczegółów.",
        },
      ],
      keywords: "wynajem samochodu brasov, wynajem auta braszów, wypożyczalnia aut brasov",
    },

    "city-cluj": {
      slug: "wynajem-samochodu-cluj-napoca",
      title: "Wynajem samochodu Cluj-Napoca | carentals.ro",
      description:
        "Wynajem samochodu w Cluj-Napoca — dostawa z Bukaresztu na zapytanie, ceny od 35 EUR/dobę, bez kaucji, RCA+CASCO w cenie.",
      eyebrow: "Stolica Transylwanii",
      h1: "Wynajem samochodu w Cluj-Napoca",
      intro:
        "Cluj-Napoca to jedno z największych miast Rumunii i ważny ośrodek akademicki. Samochód dostarczymy tu z Bukaresztu po wcześniejszym uzgodnieniu, z pełnym ubezpieczeniem i bez kaucji.",
      perks,
      sections: [
        {
          h2: "Jak zorganizować dostawę auta do Cluj-Napoca",
          body: [
            "Skontaktuj się z nami na WhatsApp +40738792499, podając miejsce i termin odbioru, a przygotujemy indywidualną wycenę dostawy samochodu z Bukaresztu.",
            "Dla osób podróżujących dalej dostępny jest wynajem jednokierunkowy — odbiór w Cluj-Napoca, a zwrot w innym mieście po zakończeniu trasy.",
          ],
        },
        {
          h2: "Zwiedzanie regionu z Cluj-Napoca",
          body: [
            "Cluj-Napoca to dobry punkt startowy do zwiedzania gór Apuseni, Turdy z jej słynną kopalnią soli oraz historycznej Alba Iulia.",
            "Dzięki nielimitowanemu przebiegowi i wliczonej rovinietcie zaplanujesz trasę po regionie bez dodatkowych opłat.",
          ],
        },
        {
          h2: "Cennik i formy płatności",
          body: [
            "Wynajem zaczyna się od 35 EUR za dobę, a koszt dostawy z Bukaresztu ustalamy indywidualnie w zależności od terminu.",
            "Płatność akceptujemy w EUR lub RON — kartą debetową, gotówką lub przelewem, bez kaucji i bez karty kredytowej.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy można wynająć auto bezpośrednio w Cluj-Napoca?",
          a: "Tak, dostarczamy samochód z Bukaresztu po wcześniejszym uzgodnieniu terminu.",
        },
        {
          q: "Ile kosztuje dostawa do Cluj-Napoca?",
          a: "Koszt ustalamy indywidualnie — napisz do nas na WhatsApp, aby otrzymać wycenę.",
        },
        {
          q: "Czy mogę zwrócić auto w innym mieście?",
          a: "Tak, oferujemy wynajem jednokierunkowy po wcześniejszym uzgodnieniu.",
        },
        {
          q: "Czy w cenie jest ubezpieczenie i rovinieta?",
          a: "Tak, każdy wynajem obejmuje ubezpieczenie RCA i CASCO oraz rovinietę.",
        },
      ],
      keywords: "wynajem samochodu cluj napoca, wynajem auta cluj, wypożyczalnia aut cluj",
    },

    "city-constanta": {
      slug: "wynajem-samochodu-konstanca",
      title: "Wynajem samochodu Konstanca (Constanta) | carentals.ro",
      description:
        "Wynajem samochodu w Konstancy — dostawa z Bukaresztu na zapytanie, ceny od 35 EUR/dobę, bez kaucji, ubezpieczenie w cenie.",
      eyebrow: "Wybrzeże Morza Czarnego",
      h1: "Wynajem samochodu w Konstancy",
      intro:
        "Konstanca i rumuńskie wybrzeże Morza Czarnego to popularny cel wakacyjny. Samochód dostarczymy z Bukaresztu po wcześniejszym uzgodnieniu, z pełnym ubezpieczeniem, rovinietą i bez kaucji.",
      perks,
      sections: [
        {
          h2: "Dostawa samochodu nad morze",
          body: [
            "Napisz do nas na WhatsApp +40738792499 z terminem i miejscem odbioru w Konstancy, a przygotujemy wycenę dostawy samochodu z Bukaresztu.",
            "Możliwy jest również wynajem jednokierunkowy — odbiór w Konstancy i zwrot w Bukareszcie po zakończeniu wakacji nad morzem.",
          ],
        },
        {
          h2: "Zwiedzanie wybrzeża z własnym autem",
          body: [
            "Własny samochód ułatwia poruszanie się między nadmorskimi kurortami — Mamaia, Wenus, Neptun czy Vama Veche znajdują się w niedalekiej odległości od Konstancy.",
            "Dzięki nielimitowanemu przebiegowi możesz codziennie odkrywać inną plażę bez martwienia się o dodatkowe opłaty za kilometry.",
          ],
        },
        {
          h2: "Ceny w sezonie letnim",
          body: [
            "Ceny wynajmu zaczynają się od 35 EUR za dobę, choć w szczycie sezonu letniego warto rezerwować auto z wyprzedzeniem ze względu na duże zainteresowanie.",
            "Płatność przyjmujemy w EUR i RON, kartą debetową, gotówką lub przelewem — bez kaucji i bez karty kredytowej.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy dostarczycie auto do Konstancy?",
          a: "Tak, organizujemy dostawę z Bukaresztu po wcześniejszym uzgodnieniu terminu i wyceny.",
        },
        {
          q: "Czy warto rezerwować auto z wyprzedzeniem w sezonie letnim?",
          a: "Tak, latem popyt jest wysoki, dlatego zalecamy rezerwację z odpowiednim wyprzedzeniem.",
        },
        {
          q: "Czy mogę zwrócić auto w Bukareszcie po pobycie nad morzem?",
          a: "Tak, oferujemy wynajem jednokierunkowy z odbiorem w Konstancy i zwrotem w Bukareszcie.",
        },
        {
          q: "Czy w cenie jest ubezpieczenie?",
          a: "Tak, każdy wynajem obejmuje ubezpieczenie RCA i CASCO oraz rovinietę.",
        },
      ],
      keywords: "wynajem samochodu konstanca, wynajem auta constanta, wypożyczalnia aut nad morzem rumunia",
    },

    cheap: {
      slug: "tani-wynajem-samochodu-rumunia",
      title: "Tani wynajem samochodu Rumunia od 35 EUR | carentals.ro",
      description:
        "Tani wynajem auta w Rumunii od 35 EUR za dobę, bez kaucji i karty kredytowej. Ubezpieczenie, rovinieta i nielimitowany przebieg w cenie.",
      eyebrow: "Najlepsza cena za dobę",
      h1: "Tani wynajem samochodu w Rumunii",
      intro:
        "Szukasz taniego wynajmu auta w Rumunii bez ukrytych kosztów? W carentals.ro ceny zaczynają się od 35 EUR za dobę i obejmują pełne ubezpieczenie, rovinietę oraz nielimitowany przebieg — bez kaucji i bez karty kredytowej.",
      perks,
      sections: [
        {
          h2: "Jak obniżyć koszt wynajmu",
          body: [
            "Im dłuższy wynajem, tym niższa stawka dzienna — rezerwacja na tydzień lub dłużej pozwala znacząco obniżyć całkowity koszt podróży.",
            "Wybór mniejszego, ekonomicznego modelu z naszej floty 28 samochodów to kolejny sposób na obniżenie kosztów, szczególnie przy jeździe głównie po mieście.",
          ],
        },
        {
          h2: "Co jest wliczone w cenę taniego wynajmu",
          body: [
            "Nawet w najniższej cenie od 35 EUR za dobę otrzymujesz ubezpieczenie RCA i CASCO, rovinietę oraz nielimitowany przebieg — bez dodatkowych opłat doliczanych na miejscu.",
            "Nie pobieramy kaucji ani nie wymagamy karty kredytowej, co dodatkowo obniża koszt startowy wynajmu w porównaniu z wieloma innymi wypożyczalniami.",
          ],
        },
        {
          h2: "Bez ukrytych opłat",
          body: [
            "Cena, którą widzisz podczas rezerwacji, jest ceną ostateczną — nie doliczamy opłat za przebieg, ubezpieczenie czy rovinietę.",
            "Jedynym dodatkowym kosztem może być dostawa pod inny adres w Bukareszcie (20 EUR) lub dostawa do innego miasta, wyceniana indywidualnie.",
          ],
        },
      ],
      faqs: [
        {
          q: "Jaka jest najniższa cena wynajmu samochodu?",
          a: "Ceny zaczynają się od 35 EUR za dobę, w zależności od modelu i długości wynajmu.",
        },
        {
          q: "Czy tania cena oznacza brak ubezpieczenia?",
          a: "Nie, każdy wynajem, niezależnie od ceny, obejmuje ubezpieczenie RCA i CASCO oraz rovinietę.",
        },
        {
          q: "Czy dłuższy wynajem jest tańszy?",
          a: "Tak, przy dłuższym okresie wynajmu stawka dzienna jest korzystniejsza.",
        },
        {
          q: "Czy muszę płacić kaucję przy tanim wynajmie?",
          a: "Nie, nie pobieramy kaucji ani nie wymagamy karty kredytowej niezależnie od wybranego auta.",
        },
      ],
      keywords: "tani wynajem samochodu rumunia, tania wypożyczalnia aut rumunia, wynajem auta rumunia tanio",
    },

    automatic: {
      slug: "wynajem-auta-automat-rumunia",
      title: "Wynajem auta automat w Rumunii | carentals.ro",
      description:
        "Wynajem samochodu z automatyczną skrzynią biegów w Rumunii. Ceny od 35 EUR/dobę, bez kaucji, ubezpieczenie i rovinieta w cenie.",
      eyebrow: "Skrzynia automatyczna",
      h1: "Wynajem auta z automatyczną skrzynią biegów",
      intro:
        "Jeśli wolisz wygodną jazdę bez sprzęgła, wybierz wynajem auta z automatyczną skrzynią biegów. W naszej flocie 28 samochodów znajdziesz modele z automatem dostępne od 35 EUR za dobę, bez kaucji i karty kredytowej.",
      perks,
      sections: [
        {
          h2: "Dlaczego warto wybrać automat w Rumunii",
          body: [
            "Rumuńskie drogi górskie, jak Transfogarska czy Transalpina, są pełne serpentyn — automatyczna skrzynia biegów ułatwia jazdę i zmniejsza zmęczenie kierowcy.",
            "Automat sprawdza się również w ruchu miejskim Bukaresztu, gdzie częste korki i zatrzymania mogą być męczące przy manualnej skrzyni.",
          ],
        },
        {
          h2: "Dostępność aut z automatem",
          body: [
            "W naszej flocie 28 samochodów regularnie dostępne są modele z automatyczną skrzynią biegów w różnych klasach — od miejskich po SUV-y i minivany.",
            "Zalecamy wcześniejszą rezerwację, ponieważ auta z automatem cieszą się dużym zainteresowaniem, szczególnie w sezonie letnim.",
          ],
        },
        {
          h2: "Cena i warunki wynajmu auta z automatem",
          body: [
            "Wynajem samochodu z automatem zaczyna się od 35 EUR za dobę i obejmuje ubezpieczenie RCA i CASCO, rovinietę oraz nielimitowany przebieg.",
            "Tak jak w przypadku pozostałych modeli, nie pobieramy kaucji ani nie wymagamy karty kredytowej — płatność w EUR lub RON, kartą debetową, gotówką lub przelewem.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy macie samochody z automatyczną skrzynią biegów?",
          a: "Tak, w naszej flocie regularnie dostępne są modele z automatem w różnych klasach.",
        },
        {
          q: "Czy wynajem auta z automatem jest droższy?",
          a: "Ceny zaczynają się od 35 EUR za dobę, podobnie jak dla innych modeli — dokładna cena zależy od wybranego auta.",
        },
        {
          q: "Czy powinienem wcześniej zarezerwować auto z automatem?",
          a: "Tak, zalecamy wcześniejszą rezerwację, ponieważ takie modele cieszą się dużym zainteresowaniem.",
        },
        {
          q: "Czy automat jest dobry na trasę Transfogarską?",
          a: "Tak, automatyczna skrzynia biegów znacznie ułatwia jazdę na górskich serpentynach.",
        },
      ],
      keywords: "wynajem auta automat rumunia, samochód z automatyczną skrzynią biegów rumunia, wynajem auta automat bukareszt",
    },

    "unlimited-km": {
      slug: "wynajem-auta-nielimitowany-przebieg",
      title: "Wynajem auta bez limitu kilometrów | carentals.ro",
      description:
        "Wynajem samochodu w Rumunii z nielimitowanym przebiegiem w cenie. Od 35 EUR/dobę, bez kaucji, ubezpieczenie RCA+CASCO wliczone.",
      eyebrow: "Bez limitu kilometrów",
      h1: "Wynajem auta z nielimitowanym przebiegiem",
      intro:
        "Każdy wynajem w carentals.ro obejmuje nielimitowany przebieg, więc planując podróż po Rumunii nie musisz liczyć kilometrów ani obawiać się dodatkowych opłat. Ceny zaczynają się od 35 EUR za dobę.",
      perks,
      sections: [
        {
          h2: "Dlaczego nielimitowany przebieg to ważna opcja",
          body: [
            "Rumunia to duży kraj z wieloma atrakcjami rozsianymi po całym terytorium — od Transylwanii po wybrzeże Morza Czarnego. Nielimitowany przebieg pozwala zaplanować trasę bez kompromisów.",
            "Wiele wypożyczalni dolicza opłaty za przekroczenie limitu kilometrów — u nas ta opcja jest wliczona w każdą rezerwację, niezależnie od długości wynajmu.",
          ],
        },
        {
          h2: "Planowanie długich tras po Rumunii",
          body: [
            "Dzięki nielimitowanemu przebiegowi możesz swobodnie łączyć w jednej podróży Bukareszt, Transfogarską, Braszów i wybrzeże Morza Czarnego bez martwienia się o dodatkowe opłaty.",
            "Ta opcja jest szczególnie przydatna przy dłuższym wynajmie, gdy planujesz przejechać przez kilka regionów kraju w ciągu jednej wizyty.",
          ],
        },
        {
          h2: "Co jeszcze jest wliczone w cenę",
          body: [
            "Oprócz nielimitowanego przebiegu, każdy wynajem obejmuje ubezpieczenie RCA i CASCO oraz rovinietę, dzięki czemu nie musisz doliczać dodatkowych kosztów.",
            "Nie pobieramy również kaucji ani nie wymagamy karty kredytowej — płatność akceptujemy w EUR lub RON, kartą debetową, gotówką lub przelewem.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy nielimitowany przebieg jest dostępny dla każdego auta?",
          a: "Tak, każda rezerwacja w carentals.ro obejmuje nielimitowany przebieg, niezależnie od modelu.",
        },
        {
          q: "Czy muszę dopłacić za dodatkowe kilometry?",
          a: "Nie, nielimitowany przebieg jest wliczony w cenę i nie generuje żadnych dodatkowych opłat.",
        },
        {
          q: "Czy ta opcja dotyczy też długich wynajmów?",
          a: "Tak, nielimitowany przebieg obowiązuje niezależnie od długości wynajmu.",
        },
        {
          q: "Jaka jest cena wynajmu z nielimitowanym przebiegiem?",
          a: "Ceny zaczynają się od 35 EUR za dobę i obejmują nielimitowany przebieg, ubezpieczenie oraz rovinietę.",
        },
      ],
      keywords: "wynajem auta nielimitowany przebieg, wynajem samochodu bez limitu km rumunia, wypożyczalnia aut bez limitu kilometrów",
    },

    "one-way": {
      slug: "wynajem-samochodu-jednokierunkowy-rumunia",
      title: "Wynajem samochodu jednokierunkowy Rumunia | carentals.ro",
      description:
        "Wynajem auta jednokierunkowy w Rumunii — odbiór w jednym mieście, zwrot w innym, na zapytanie. Ceny od 35 EUR/dobę, bez kaucji.",
      eyebrow: "Odbiór i zwrot w różnych miastach",
      h1: "Wynajem samochodu jednokierunkowy w Rumunii",
      intro:
        "Planujesz trasę przez Rumunię i chcesz odebrać auto w jednym miejscu, a zwrócić w innym? Wynajem jednokierunkowy w carentals.ro organizujemy indywidualnie po kontakcie na WhatsApp, z jasną wyceną i pełnym ubezpieczeniem w cenie.",
      perks,
      sections: [
        {
          h2: "Jak działa wynajem jednokierunkowy",
          body: [
            "Napisz do nas na WhatsApp +40738792499, podając miasto odbioru i miasto zwrotu samochodu, a przygotujemy indywidualną wycenę uwzględniającą odległość i logistykę.",
            "Ta opcja jest szczególnie wygodna przy podróżach w jedną stronę, na przykład z Bukaresztu do Braszowa, Sibiu lub na wybrzeże Morza Czarnego.",
          ],
        },
        {
          h2: "Dla kogo jest ta opcja",
          body: [
            "Wynajem jednokierunkowy sprawdza się dla podróżnych, którzy lądują w jednym mieście, a wylatują z innego, lub planują trasę bez powrotu do punktu startowego.",
            "Sprawdza się też przy podróżach łączących lotnisko Otopeni z innymi regionami Rumunii, gdy nie chcesz wracać po samochód do Bukaresztu.",
          ],
        },
        {
          h2: "Co jest wliczone w cenę",
          body: [
            "Niezależnie od trasy, każdy wynajem obejmuje ubezpieczenie RCA i CASCO, rovinietę oraz nielimitowany przebieg, zaczynając od 35 EUR za dobę plus koszt logistyki.",
            "Nie pobieramy kaucji ani nie wymagamy karty kredytowej — płatność akceptujemy w EUR lub RON, kartą debetową, gotówką lub przelewem.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy mogę odebrać auto w jednym mieście, a zwrócić w innym?",
          a: "Tak, oferujemy wynajem jednokierunkowy po wcześniejszym uzgodnieniu trasy i wyceny.",
        },
        {
          q: "Jak zamówić wynajem jednokierunkowy?",
          a: "Napisz do nas na WhatsApp z miastem odbioru i zwrotu, a przygotujemy wycenę.",
        },
        {
          q: "Czy ta usługa kosztuje dodatkowo?",
          a: "Tak, do standardowej ceny wynajmu doliczany jest koszt logistyki, ustalany indywidualnie.",
        },
        {
          q: "Czy nadal obowiązuje brak kaucji przy wynajmie jednokierunkowym?",
          a: "Tak, warunki bez kaucji i bez karty kredytowej obowiązują niezależnie od trasy.",
        },
      ],
      keywords: "wynajem samochodu jednokierunkowy rumunia, wynajem auta one way rumunia, wypożyczalnia aut odbiór i zwrot w innym mieście",
    },

    "seven-seater": {
      slug: "wynajem-samochodu-7-osobowego-rumunia",
      title: "Wynajem samochodu 7-osobowego Rumunia | carentals.ro",
      description:
        "Wynajem minivana 7-osobowego w Rumunii od 35 EUR/dobę. Bez kaucji, ubezpieczenie RCA+CASCO i rovinieta w cenie, odbiór na Otopeni.",
      eyebrow: "Minivan dla całej rodziny",
      h1: "Wynajem samochodu 7-osobowego w Rumunii",
      intro:
        "Podróżujesz większą grupą lub rodziną? W naszej flocie 28 samochodów znajdziesz 7-osobowe minivany idealne na wycieczki po Rumunii, dostępne od 35 EUR za dobę, bez kaucji i karty kredytowej.",
      perks,
      sections: [
        {
          h2: "Kiedy warto wybrać auto 7-osobowe",
          body: [
            "Minivan 7-osobowy sprawdza się przy podróżach rodzinnych, wyjazdach z większą ilością bagażu oraz wspólnych wycieczkach grupy znajomych po Rumunii.",
            "To wygodny wybór na trasy takie jak Transfogarska, Transylwania czy wybrzeże Morza Czarnego, gdzie liczy się zarówno przestrzeń dla pasażerów, jak i miejsce na bagaż.",
          ],
        },
        {
          h2: "Dostępność i rezerwacja minivana",
          body: [
            "Ponieważ liczba samochodów 7-osobowych w naszej flocie jest ograniczona, zalecamy rezerwację z wyprzedzeniem, szczególnie w sezonie letnim i w okresach świątecznych.",
            "Odbiór minivana jest możliwy bezpłatnie w naszym biurze w Bukareszcie lub na lotnisku Otopeni, dostępny 24 godziny na dobę.",
          ],
        },
        {
          h2: "Cena i warunki wynajmu",
          body: [
            "Wynajem samochodu 7-osobowego zaczyna się od 35 EUR za dobę i obejmuje ubezpieczenie RCA i CASCO, rovinietę oraz nielimitowany przebieg.",
            "Nie pobieramy kaucji ani nie wymagamy karty kredytowej — płatność akceptujemy w EUR lub RON, kartą debetową, gotówką lub przelewem.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy macie samochody 7-osobowe w ofercie?",
          a: "Tak, w naszej flocie 28 samochodów znajdują się minivany 7-osobowe dostępne od 35 EUR za dobę.",
        },
        {
          q: "Czy warto rezerwować minivan z wyprzedzeniem?",
          a: "Tak, liczba samochodów 7-osobowych jest ograniczona, dlatego zalecamy wcześniejszą rezerwację.",
        },
        {
          q: "Gdzie mogę odebrać minivana?",
          a: "Odbiór jest bezpłatny w naszym biurze w Bukareszcie oraz na lotnisku Otopeni, dostępny 24/7.",
        },
        {
          q: "Czy w cenie minivana jest ubezpieczenie?",
          a: "Tak, każdy wynajem obejmuje ubezpieczenie RCA i CASCO, rovinietę oraz nielimitowany przebieg.",
        },
      ],
      keywords: "wynajem samochodu 7 osobowego rumunia, wynajem minivana rumunia, wypożyczalnia aut 7 osobowych bukareszt",
    },

    "guide-transfagarasan": {
      slug: "przewodnik-trasa-transfogarska",
      title: "Trasa Transfogarska — przewodnik i wynajem auta | carentals.ro",
      description:
        "Jak zaplanować trasę Transfogarską (DN7C)? Przewodnik i wynajem samochodu od 35 EUR/dobę, z ubezpieczeniem i rovinietą w cenie.",
      eyebrow: "Przewodnik po drogach Rumunii",
      h1: "Trasa Transfogarska — przewodnik dla kierowców",
      intro:
        "Transfogarska (DN7C) to jedna z najsłynniejszych górskich dróg w Europie, łącząca Transylwanię z Wołoszczyzną przez pasmo Fogarasz. Wynajmij samochód w carentals.ro i pokonaj tę trasę z pełnym ubezpieczeniem oraz nielimitowanym przebiegiem.",
      perks: guidePerks,
      sections: [
        {
          h2: "Kiedy jechać Transfogarską",
          body: [
            "Droga DN7C jest zwykle otwarta od czerwca do października — poza tym okresem wysokogórski odcinek bywa zamknięty z powodu śniegu. Warto sprawdzić aktualny status przed wyjazdem.",
            "Najlepszą porą na przejazd jest wczesny ranek, kiedy na serpentynach jest mniej ruchu turystycznego, a widoki na jezioro Bâlea są najbardziej malownicze.",
          ],
        },
        {
          h2: "Jakie auto wybrać na Transfogarską",
          body: [
            "Ze względu na liczne zakręty i strome podjazdy dobrze sprawdza się samochód z automatyczną skrzynią biegów oraz odpowiednią mocą silnika, dostępny w naszej flocie 28 aut.",
            "Nielimitowany przebieg pozwala połączyć Transfogarską z dalszą podróżą po Transylwanii bez dodatkowych opłat za kilometry.",
          ],
        },
        {
          h2: "Praktyczne wskazówki",
          body: [
            "Zatankuj pełny bak przed wjazdem na trasę, ponieważ stacje paliw na samej Transfogarskiej są nieliczne. Zabierz też ciepłą odzież — na wysokości temperatura bywa znacznie niższa niż w dolinie.",
            "Rovinieta jest wliczona w każdy nasz wynajem, więc nie musisz się martwić o dodatkowe formalności drogowe przed wjazdem na trasę.",
          ],
        },
      ],
      faqs: [
        {
          q: "Kiedy Transfogarska jest otwarta dla ruchu?",
          a: "Zazwyczaj od czerwca do października, w zależności od warunków pogodowych na wysokogórskim odcinku.",
        },
        {
          q: "Jakie auto najlepiej sprawdzi się na tej trasie?",
          a: "Polecamy auto z automatyczną skrzynią biegów i dobrą mocą silnika, dostępne w naszej flocie.",
        },
        {
          q: "Czy rovinieta jest potrzebna na Transfogarskiej?",
          a: "Tak, rovinieta jest wymagana na drogach krajowych i jest wliczona w każdy nasz wynajem.",
        },
        {
          q: "Czy mogę wynająć auto z nielimitowanym przebiegiem na tę trasę?",
          a: "Tak, każdy wynajem w carentals.ro obejmuje nielimitowany przebieg.",
        },
      ],
      keywords: "trasa transfogarska, transfogarska przewodnik, wynajem auta transfogarska",
    },

    "guide-transylvania": {
      slug: "przewodnik-transylwania-wynajem-auta",
      title: "Transylwania — przewodnik i wynajem samochodu | carentals.ro",
      description:
        "Zaplanuj podróż po Transylwanii — zamki, góry i średniowieczne miasta. Wynajem auta od 35 EUR/dobę, bez kaucji, ubezpieczenie w cenie.",
      eyebrow: "Przewodnik po regionach Rumunii",
      h1: "Transylwania — przewodnik dla podróżujących własnym autem",
      intro:
        "Transylwania to region zamków, średniowiecznych miast i górskich krajobrazów, najlepiej zwiedzany własnym samochodem. Wynajmij auto w carentals.ro i odkryj Braszów, Sibiu, Cluj oraz zamek Bran bez limitu kilometrów.",
      perks: guidePerks,
      sections: [
        {
          h2: "Najważniejsze miejsca w Transylwanii",
          body: [
            "Warto zaplanować wizytę w Braszowie i pobliskim zamku Bran, znanym jako zamek Draculi, a także w Sibiu z jego zabytkowym Starym Miastem i Sighișoarze — rodzinnym mieście Vlada Palownika.",
            "Cluj-Napoca i góry Apuseni to kolejne atrakcje regionu — dzięki własnemu samochodowi łatwo połączysz te miejsca w jedną trasę bez czekania na transport publiczny.",
          ],
        },
        {
          h2: "Planowanie trasy samochodem",
          body: [
            "Dzięki nielimitowanemu przebiegowi możesz swobodnie zaplanować trasę okrężną przez kilka miast Transylwanii, bez martwienia się o dodatkowe opłaty za kilometry.",
            "Odbiór samochodu jest możliwy w Bukareszcie lub na lotnisku Otopeni, a dostawę do miast Transylwanii organizujemy na zapytanie przez WhatsApp.",
          ],
        },
        {
          h2: "Praktyczne informacje",
          body: [
            "Rovinieta jest wliczona w cenę wynajmu, więc od razu po odbiorze auta możesz wjechać na wszystkie drogi krajowe regionu.",
            "Warto zarezerwować nocleg z wyprzedzeniem w sezonie letnim, kiedy Transylwania przyciąga wielu turystów, szczególnie w weekendy.",
          ],
        },
      ],
      faqs: [
        {
          q: "Jakie miasta warto odwiedzić w Transylwanii?",
          a: "Polecamy Braszów, Sibiu, Sighișoarę oraz Cluj-Napoca, a także zamek Bran.",
        },
        {
          q: "Czy mogę wynająć auto w Bukareszcie na trasę po Transylwanii?",
          a: "Tak, odbierzesz auto w Bukareszcie lub na lotnisku Otopeni i pojedziesz bez limitu kilometrów.",
        },
        {
          q: "Czy dostawa auta do miast Transylwanii jest możliwa?",
          a: "Tak, organizujemy dostawę na zapytanie przez WhatsApp z indywidualną wyceną.",
        },
        {
          q: "Czy rovinieta jest wliczona w cenę?",
          a: "Tak, rovinieta jest już wliczona w każdy nasz wynajem samochodu.",
        },
      ],
      keywords: "transylwania przewodnik, wynajem auta transylwania, zwiedzanie transylwanii samochodem",
    },

    "guide-black-sea": {
      slug: "przewodnik-wybrzeze-morza-czarnego-wynajem-auta",
      title: "Wybrzeże Morza Czarnego — przewodnik i wynajem auta | carentals.ro",
      description:
        "Plan wakacji nad Morzem Czarnym w Rumunii. Wynajem samochodu od 35 EUR/dobę, bez kaucji, ubezpieczenie i rovinieta w cenie.",
      eyebrow: "Przewodnik po wybrzeżu",
      h1: "Wybrzeże Morza Czarnego — przewodnik dla kierowców",
      intro:
        "Rumuńskie wybrzeże Morza Czarnego z kurortami Mamaia, Wenus czy Vama Veche to popularny cel letnich wyjazdów. Wynajmij samochód w carentals.ro i swobodnie zwiedzaj wybrzeże bez limitu kilometrów.",
      perks: guidePerks,
      sections: [
        {
          h2: "Najpopularniejsze kurorty nad Morzem Czarnym",
          body: [
            "Mamaia to najbardziej znany kurort blisko Konstancy, z rozbudowaną infrastrukturą turystyczną, a Vama Veche przyciąga młodszych podróżnych szukających mniej formalnej atmosfery.",
            "Warto też odwiedzić Wenus, Neptun i Saturn — spokojniejsze miejscowości wypoczynkowe położone wzdłuż wybrzeża, do których łatwo dotrzeć własnym samochodem.",
          ],
        },
        {
          h2: "Dlaczego warto mieć auto nad morzem",
          body: [
            "Własny samochód pozwala codziennie zmieniać plażę i kurort bez uzależniania się od rozkładu transportu publicznego, szczególnie w sezonie letnim.",
            "Dzięki nielimitowanemu przebiegowi możesz też zaplanować wypad do Delty Dunaju lub do historycznej Konstancy bez dodatkowych opłat za kilometry.",
          ],
        },
        {
          h2: "Rezerwacja auta na sezon letni",
          body: [
            "W szczycie sezonu letniego popyt na samochody nad morzem jest wysoki, dlatego warto rezerwować auto z odpowiednim wyprzedzeniem.",
            "Auto możesz odebrać w Bukareszcie lub na lotnisku Otopeni, a dostawę bezpośrednio do Konstancy organizujemy na zapytanie przez WhatsApp.",
          ],
        },
      ],
      faqs: [
        {
          q: "Jakie kurorty warto odwiedzić nad Morzem Czarnym w Rumunii?",
          a: "Polecamy Mamaię, Wenus, Neptun, Saturn oraz Vama Veche.",
        },
        {
          q: "Czy warto mieć samochód podczas wakacji nad morzem?",
          a: "Tak, ułatwia to poruszanie się między kurortami i zwiedzanie okolic, np. Delty Dunaju.",
        },
        {
          q: "Czy dostarczycie auto do Konstancy?",
          a: "Tak, dostawę organizujemy na zapytanie przez WhatsApp z indywidualną wyceną.",
        },
        {
          q: "Czy warto rezerwować auto z wyprzedzeniem latem?",
          a: "Tak, w sezonie letnim popyt jest wysoki, dlatego zalecamy wcześniejszą rezerwację.",
        },
      ],
      keywords: "wybrzeże morza czarnego rumunia, wynajem auta konstanca wakacje, przewodnik wybrzeże rumunia",
    },

    "rules-rovinieta": {
      slug: "rovinieta-rumunia-przepisy",
      title: "Rovinieta w Rumunii — co musisz wiedzieć | carentals.ro",
      description:
        "Czym jest rovinieta w Rumunii i kiedy jest wymagana? Wyjaśniamy przepisy — w carentals.ro rovinieta jest wliczona w cenę wynajmu.",
      eyebrow: "Przepisy drogowe w Rumunii",
      h1: "Rovinieta w Rumunii — najważniejsze informacje",
      intro:
        "Rovinieta to elektroniczna winieta drogowa wymagana na drogach krajowych i autostradach w Rumunii. W carentals.ro rovinieta jest już wliczona w cenę każdego wynajmu, więc nie musisz się nią martwić.",
      perks: rulesPerks,
      sections: [
        {
          h2: "Czym jest rovinieta",
          body: [
            "Rovinieta to elektroniczna opłata drogowa, obowiązkowa dla większości pojazdów poruszających się po drogach krajowych i autostradach w Rumunii. System jest w pełni elektroniczny i opiera się na numerze rejestracyjnym pojazdu.",
            "Brak ważnej rovinietty grozi wysokim mandatem, dlatego przed wyjazdem warto upewnić się, że jest ona aktywna dla wynajmowanego samochodu.",
          ],
        },
        {
          h2: "Rovinieta w carentals.ro",
          body: [
            "Każdy samochód wynajmowany w carentals.ro ma już aktywną rovinietę, więc od razu po odbiorze możesz wjechać na drogi krajowe bez dodatkowych formalności.",
            "Nie musisz samodzielnie kupować winiety ani sprawdzać jej ważności — zajmujemy się tym za Ciebie przy każdej rezerwacji.",
          ],
        },
        {
          h2: "Na jakich drogach obowiązuje rovinieta",
          body: [
            "Rovinieta obowiązuje na drogach krajowych (DN) oraz autostradach w całej Rumunii, ale nie jest wymagana w obrębie miast ani na niektórych drogach lokalnych.",
            "Planując dłuższą trasę, np. Transfogarską czy podróż do Transylwanii, warto wiedzieć, że nasza rovinieta pokrywa te odcinki bez dodatkowych opłat.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy muszę osobno kupić rovinietę?",
          a: "Nie, rovinieta jest wliczona w każdy wynajem samochodu w carentals.ro.",
        },
        {
          q: "Co grozi za brak ważnej rovinietty?",
          a: "Brak ważnej winiety wiąże się z wysokim mandatem, dlatego zawsze aktywujemy ją dla naszych samochodów.",
        },
        {
          q: "Na jakich drogach obowiązuje rovinieta?",
          a: "Na drogach krajowych i autostradach w całej Rumunii, ale nie w obrębie miast.",
        },
        {
          q: "Czy rovinieta obowiązuje na trasie Transfogarskiej?",
          a: "Tak, i jest ona wliczona w cenę wynajmu naszego samochodu.",
        },
      ],
      keywords: "rovinieta rumunia, winieta drogowa rumunia, rovinieta przepisy",
    },

    "rules-winter-tires": {
      slug: "zimowe-opony-rumunia-przepisy",
      title: "Opony zimowe w Rumunii — przepisy | carentals.ro",
      description:
        "Kiedy w Rumunii obowiązują opony zimowe? Wyjaśniamy przepisy — nasze samochody są przygotowane na zimowe warunki.",
      eyebrow: "Przepisy drogowe w Rumunii",
      h1: "Opony zimowe w Rumunii — co musisz wiedzieć",
      intro:
        "Rumuńskie przepisy wymagają odpowiedniego wyposażenia zimowego w określonych warunkach pogodowych. Samochody wynajmowane w carentals.ro są przygotowane na zimę, dzięki czemu bezpiecznie poruszasz się po drogach kraju o każdej porze roku.",
      perks: rulesPerks,
      sections: [
        {
          h2: "Kiedy obowiązują opony zimowe w Rumunii",
          body: [
            "Zgodnie z rumuńskimi przepisami, w przypadku opadów śniegu, oblodzenia lub temperatury poniżej 7°C, samochody powinny być wyposażone w opony zimowe lub całoroczne z odpowiednim oznaczeniem.",
            "Dotyczy to zwłaszcza okresu od listopada do marca, choć w praktyce warunki pogodowe mogą zmieniać się w zależności od regionu i wysokości nad poziomem morza.",
          ],
        },
        {
          h2: "Jak przygotowane są nasze samochody",
          body: [
            "W okresie zimowym samochody w naszej flocie wyposażamy w opony zimowe, zgodnie z obowiązującymi przepisami, dzięki czemu nie musisz się martwić o dodatkowe przygotowania.",
            "Dotyczy to zarówno pojazdów odbieranych w Bukareszcie, jak i tych dostarczanych do innych miast Rumunii.",
          ],
        },
        {
          h2: "Jazda zimą po górskich trasach",
          body: [
            "Warto pamiętać, że niektóre górskie drogi, jak Transfogarska, są zimą całkowicie zamknięte dla ruchu ze względu na warunki śniegowe.",
            "Przed planowaniem zimowej podróży po Rumunii warto skonsultować z nami trasę na WhatsApp +40738792499, abyśmy mogli doradzić najlepszy wybór auta i drogi.",
          ],
        },
      ],
      faqs: [
        {
          q: "Czy w Rumunii obowiązkowe są opony zimowe?",
          a: "Tak, w warunkach śniegu, oblodzenia lub niskich temperatur wymagane są opony zimowe lub całoroczne.",
        },
        {
          q: "Czy wasze samochody mają opony zimowe?",
          a: "Tak, w sezonie zimowym nasza flota jest wyposażona w opony zimowe zgodnie z przepisami.",
        },
        {
          q: "Czy Transfogarska jest dostępna zimą?",
          a: "Nie, wysokogórski odcinek trasy Transfogarskiej jest zwykle zamknięty zimą.",
        },
        {
          q: "Do kiedy obowiązują przepisy o oponach zimowych?",
          a: "Zasadniczo obowiązują od listopada do marca, choć zależy to od aktualnych warunków pogodowych.",
        },
      ],
      keywords: "opony zimowe rumunia, przepisy zimowe rumunia, jazda zimą po rumunii",
    },

    "rules-speed-cameras": {
      slug: "fotoradary-limity-predkosci-rumunia",
      title: "Fotoradary i limity prędkości w Rumunii | carentals.ro",
      description:
        "Jakie są limity prędkości i gdzie stoją fotoradary w Rumunii? Praktyczny przewodnik dla kierowców wynajmujących samochód.",
      eyebrow: "Przepisy drogowe w Rumunii",
      h1: "Fotoradary i limity prędkości w Rumunii",
      intro:
        "Zanim wyruszysz w trasę wynajętym samochodem, warto poznać obowiązujące w Rumunii limity prędkości oraz zasady dotyczące fotoradarów. Pomoże to uniknąć mandatów i bezpiecznie dotrzeć do celu.",
      perks: rulesPerks,
      sections: [
        {
          h2: "Limity prędkości w Rumunii",
          body: [
            "W terenie zabudowanym obowiązuje limit 50 km/h, poza terenem zabudowanym zwykle 90 km/h, a na drogach ekspresowych i autostradach odpowiednio 100 i 130 km/h, o ile znaki nie wskazują inaczej.",
            "Warto zwracać uwagę na znaki ograniczające prędkość przy wjazdach do miejscowości, ponieważ limity mogą się zmieniać na krótkich odcinkach.",
          ],
        },
        {
          h2: "Fotoradary i kontrole policyjne",
          body: [
            "W Rumunii fotoradary są rozmieszczone zarówno na drogach krajowych, jak i w obrębie miast, a policja regularnie prowadzi kontrole prędkości przy użyciu radarów ręcznych.",
            "Mandaty za przekroczenie prędkości mogą być dotkliwe, dlatego zalecamy zachowanie ostrożności, zwłaszcza w okolicach przejść dla pieszych i skrzyżowań.",
          ],
        },
        {
          h2: "Bezpieczna jazda wynajętym samochodem",
          body: [
            "Nasze samochody są regularnie serwisowane i sprawdzane pod kątem bezpieczeństwa, co ułatwia przestrzeganie przepisów i komfortową jazdę po Rumunii.",
            "W razie jakichkolwiek pytań dotyczących przepisów drogowych możesz skontaktować się z nami na WhatsApp +40738792499 przed lub w trakcie podróży.",
          ],
        },
      ],
      faqs: [
        {
          q: "Jaki jest limit prędkości w terenie zabudowanym w Rumunii?",
          a: "Standardowy limit w terenie zabudowanym wynosi 50 km/h, o ile znaki nie stanowią inaczej.",
        },
        {
          q: "Czy w Rumunii jest dużo fotoradarów?",
          a: "Tak, fotoradary znajdują się zarówno na drogach krajowych, jak i w obrębie miast.",
        },
        {
          q: "Jaki jest limit prędkości na autostradzie?",
          a: "Na autostradach obowiązuje zwykle limit 130 km/h, chyba że znaki wskazują inaczej.",
        },
        {
          q: "Co zrobić w razie pytań o przepisy drogowe?",
          a: "Możesz skontaktować się z nami bezpośrednio na WhatsApp +40738792499.",
        },
      ],
      keywords: "fotoradary rumunia, limity prędkości rumunia, przepisy drogowe rumunia",
    },

    "airport-pickup": {
      slug: "odbior-samochodu-lotnisko-otopeni-krok-po-kroku",
      title: "Odbiór samochodu na Otopeni krok po kroku | carentals.ro",
      description:
        "Jak odebrać wynajęty samochód na lotnisku Otopeni? Krok po kroku, bez kaucji, odbiór 24/7 bezpośrednio przy terminalu.",
      eyebrow: "Instrukcja krok po kroku",
      h1: "Jak odebrać samochód na lotnisku Otopeni",
      intro:
        "Odbiór samochodu na lotnisku Henri Coandă (Otopeni) jest prosty i zajmuje tylko kilka minut. Poniżej znajdziesz dokładny opis kroków, dzięki którym sprawnie odbierzesz auto o każdej porze dnia i nocy.",
      perks: airportPerksOtopeni,
      sections: [
        {
          h2: "Krok 1 i 2: rezerwacja i kontakt po lądowaniu",
          body: [
            "Zarezerwuj samochód online z wyprzedzeniem, podając numer lotu oraz przewidywaną godzinę lądowania — dzięki temu przygotujemy auto na Twój przylot.",
            "Po wylądowaniu i odebraniu bagażu napisz do nas na WhatsApp +40738792499, informując, że jesteś już na lotnisku. Nasz przedstawiciel ustali z Tobą dokładne miejsce spotkania przy terminalu.",
          ],
        },
        {
          h2: "Krok 3 i 4: formalności i odbiór kluczy",
          body: [
            "Na miejscu okażesz prawo jazdy oraz dowód tożsamości lub paszport. Ponieważ nie wymagamy kaucji ani karty kredytowej, formalności trwają zaledwie kilka minut.",
            "Po podpisaniu umowy wynajmu otrzymasz klucze oraz krótki przegląd stanu technicznego samochodu wraz z dokumentami — ubezpieczeniem RCA i CASCO oraz aktywną rovinietą.",
          ],
        },
        {
          h2: "Krok 5: wyjazd z lotniska",
          body: [
            "Po odbiorze kluczy możesz od razu wyruszyć w trasę — czy to do centrum Bukaresztu, czy dalej w kierunku Transylwanii lub wybrzeża Morza Czarnego, bez limitu kilometrów.",
            "Jeśli masz jakiekolwiek pytania w trakcie podróży, pozostajemy w kontakcie na WhatsApp przez cały okres wynajmu, 24 godziny na dobę.",
          ],
        },
      ],
      faqs: [
        {
          q: "Ile trwa odbiór samochodu na lotnisku Otopeni?",
          a: "Zazwyczaj kilkanaście minut, ponieważ nie wymagamy kaucji ani karty kredytowej.",
        },
        {
          q: "Co powinienem zrobić od razu po wylądowaniu?",
          a: "Napisz do nas na WhatsApp +40738792499, a nasz przedstawiciel ustali miejsce spotkania przy terminalu.",
        },
        {
          q: "Jakie dokumenty są potrzebne do odbioru auta?",
          a: "Wystarczy prawo jazdy oraz dowód tożsamości lub paszport.",
        },
        {
          q: "Czy odbiór jest możliwy o każdej porze?",
          a: "Tak, odbiór samochodu na lotnisku Otopeni jest dostępny 24 godziny na dobę, 7 dni w tygodniu.",
        },
      ],
      keywords: "odbiór samochodu lotnisko otopeni, jak odebrać wynajęte auto bukareszt, wynajem auta otopeni krok po kroku",
    },
  },
};
